import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items = [] }) {
    return (
        <div className="border-y border-forest bg-sand py-6" data-testid="editorial-marquee">
            <Marquee gradient={false} speed={40} pauseOnHover>
                <div className="marquee-track flex items-center">
                    {items.concat(items).map((t, i) => (
                        <span key={i} className="font-serif italic text-forest text-4xl md:text-6xl leading-none">
                            {t}
                            <span className="text-clay mx-6">✦</span>
                        </span>
                    ))}
                </div>
            </Marquee>
        </div>
    );
}
